/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdhess_Hochschulangehoerige26Inputs */

const en__field_enum_sdhess_hochschulangehoerige26 = /** @type {(inputs: _Field_Enum_Sdhess_Hochschulangehoerige26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hess. Hochschulangehörige/r`)
};

const de__field_enum_sdhess_hochschulangehoerige26 = /** @type {(inputs: _Field_Enum_Sdhess_Hochschulangehoerige26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hess. Hochschulangehörige/r`)
};

/**
* | output |
* | --- |
* | "Hess. Hochschulangehörige/r" |
*
* @param {_Field_Enum_Sdhess_Hochschulangehoerige26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdhess_hochschulangehoerige26 = /** @type {((inputs?: _Field_Enum_Sdhess_Hochschulangehoerige26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdhess_Hochschulangehoerige26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdhess_hochschulangehoerige26(inputs)
	return de__field_enum_sdhess_hochschulangehoerige26(inputs)
});
export { _field_enum_sdhess_hochschulangehoerige26 as "_field_enum_SDHESS_HOCHSCHULANGEHOERIGE" }